/* eslint-disable filenames/match-exported */

import { useFeatureFlag } from '@datacamp/exercise-feature-flags';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getTranscript, setPlaybackRate, setQuality, setSubtitle } from '../actions';
import { getAiCoachContent } from '../actions/actionCreators/aiCoach/getAiCoachContent';
import { getCourse } from '../actions/actionCreators/courses/getCourse';
import { useSubtitleLanguage } from '../hooks/useSubtitleLanguage';
import VideoWithDynamicTranscript from './VideoWithDynamicTranscript';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const aiVoicesCourseIds = [
// translated course ids
34814, 34856, 34842, 34442, 34849, 34850,
// Translated with full AI Voice flow - es
36924, 38866, 37237, 38444, 36775, 36928, 36772, 36753, 36951, 36931, 36944, 36949, 39187, 38380, 39120, 38144, 38563, 38890, 38375, 36934, 36939, 37206, 36937, 37055, 36961, 36554, 36926, 36930,
// AI branch courses
37694, 37722, 37739, 37727, 37741, 37745];
const mapStateToProps = state => ({
  aiCoachContent: state.aiCoachContent,
  course: state.course,
  playbackRate: state.globalSettings.playbackRate,
  quality: state.globalSettings.quality,
  selectedSubtitle: state.globalSettings.selectedSubtitle,
  transcript: state.transcript
});
const mapDispatchToProps = dispatch => ({
  loadAiCoachContent: _ref => {
    let {
      campusApiUrl,
      exerciseId,
      languageCode
    } = _ref;
    dispatch(getAiCoachContent({
      campusApiUrl,
      exerciseId,
      languageCode
    }));
  },
  loadCourse: _ref2 => {
    let {
      campusApiUrl,
      courseId
    } = _ref2;
    dispatch(getCourse({
      campusApiUrl,
      courseId
    }));
  },
  onLoadTranscript: _ref3 => {
    let {
      exerciseId,
      projectorKey,
      projectorUrl
    } = _ref3;
    dispatch(getTranscript({
      exerciseId,
      projectorKey,
      projectorUrl
    }));
  },
  onSetPlaybackRate: _ref4 => {
    let {
      playbackRate
    } = _ref4;
    dispatch(setPlaybackRate({
      playbackRate
    }));
  },
  onSetQuality: _ref5 => {
    let {
      quality
    } = _ref5;
    dispatch(setQuality({
      quality
    }));
  },
  onSetSubtitle: _ref6 => {
    let {
      selectedSubtitle
    } = _ref6;
    dispatch(setSubtitle({
      selectedSubtitle
    }));
  }
});
const videoExerciseConnector = connect(mapStateToProps, mapDispatchToProps);
const VideoExercise = _ref7 => {
  var _useFeatureFlag$flag;
  let {
    aiCoachContent,
    campusApiUrl,
    course,
    environment,
    exercise: {
      assignment,
      id,
      projectorKey,
      title,
      videoHls,
      videoLink,
      xp
    },
    isActive,
    isLoggedIn,
    language,
    loadAiCoachContent,
    loadCourse,
    onComplete,
    onLoadTranscript,
    onSetPlaybackRate,
    onSetQuality,
    onSetSubtitle,
    playbackRate,
    projectorUrl,
    quality,
    selectedSubtitle,
    setIsComplete,
    trackPlayerEvent,
    transcript,
    userId
  } = _ref7;
  const [shouldPlay, setShouldPlay] = useState(false);

  // Projector keys are assumed to be in format: course_28921_c2c9510956d548ee1a27762bf67b564c,
  // where the second segment is course id
  const courseId = projectorKey === null || projectorKey === void 0 ? void 0 : projectorKey.split('_')[1];

  // Subtitles should be disabled if we are using translated key and the course is on the list
  const subtitlesDisabled = ((_useFeatureFlag$flag = useFeatureFlag('ts--campus-api-use-translated-projector-key').flag) !== null && _useFeatureFlag$flag !== void 0 ? _useFeatureFlag$flag : 'off') === 'on' && courseId !== undefined && aiVoicesCourseIds.includes(parseInt(courseId, 10));
  const subtitleLanguage = useSubtitleLanguage({
    onSetSubtitle,
    selectedSubtitle,
    userLanguage: language
  });
  useEffect(() => {
    if (!isLoggedIn) {
      return;
    }
    loadCourse({
      campusApiUrl,
      courseId: Number(courseId)
    });
  }, [loadCourse, isLoggedIn, campusApiUrl, courseId]);
  useEffect(() => {
    if (!isLoggedIn) {
      return;
    }
    loadAiCoachContent({
      campusApiUrl,
      exerciseId: id,
      languageCode: language
    });
  }, [id, language, loadAiCoachContent, isLoggedIn, campusApiUrl]);
  useEffect(() => {
    if (projectorKey != null) {
      onLoadTranscript({
        exerciseId: id,
        projectorKey,
        projectorUrl
      });
    }
  }, [id, projectorKey, projectorUrl, onLoadTranscript]);
  const transcriptToShow = transcript[id];
  return ___EmotionJSX(VideoWithDynamicTranscript, {
    aiCoachContent: aiCoachContent,
    assignment: assignment,
    campusApiUrl: campusApiUrl,
    course: course,
    environment: environment,
    id: id,
    isActive: isActive,
    isLoggedIn: isLoggedIn,
    onComplete: onComplete,
    onSetPlaybackRate: onSetPlaybackRate,
    onSetQuality: onSetQuality,
    onSetSubtitle: onSetSubtitle,
    playbackRate: playbackRate,
    projectorKey: projectorKey,
    projectorUrl: projectorUrl,
    quality: quality,
    setIsComplete: setIsComplete,
    setShouldPlay: setShouldPlay,
    shouldPlay: shouldPlay,
    subtitleLanguage: subtitlesDisabled ? 'none' : subtitleLanguage,
    title: title,
    trackPlayerEvent: trackPlayerEvent,
    transcriptToShow: transcriptToShow,
    userId: userId,
    videoHls: videoHls,
    videoLink: videoLink,
    xp: xp
  });
};
export const UnconnectedVideoExercise = VideoExercise;
export default videoExerciseConnector(VideoExercise);